export const TEXTS = {
  MODAL_TITLE: 'Плеер Звук Бизнес',
  MODAL_VIDEO_TITLE: 'Плеер Звук Бизнес — решение для любого телевизора',

  MODAL_AUDIO_DESCRIPTION:
    'Компактный плеер с HDMI-кабелем: включается в розетку и в телевизор — сразу работает с любыми форматами: и музыка, и видео.',

  SUCCESS_DISABLED_BUTTON: 'Запрос отправлен',
  SUCCESS_BUTTON: 'Отправить запрос',
  CANCEL_BUTTON: 'Назад',

  HAVE_REQUEST_NOTE: 'Менеджер свяжется в течение рабочего дня',

  FEATURES_INTERNET: 'Работает даже при нестабильном интернете',
  FEATURES_DEVICES: 'Не требует дополнительных устройств',
  FEATURES_AUDIO: 'Огромный выбор аудиволн',
  FEATURES_VIDEO: 'Доступ к видеоволнам',

  DISABLED_BUTTON_BINDED_HINT: 'Этот тип устройства сейчас привязан',
};
